export enum OrderStylesOverviewTestLabelEnum {
  CABINET_BOX_MATERIAL_LBL = 'cabinet-box-material-lbl',
  WOOD_LBL = 'wood-lbl',
  WOOD_INTERIOR_LBL = 'wood-interior-lbl',
}
